import { ToastContainer } from "react-toastify"; 

const ErrorHandler = {
  success,
};

const options = {
  position: "top-right",
  autoClose: 8000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

function success(response) {
  if (response) {
    if (response.success) {
      return true;
    } else {
      // Ver HttpService.interceptors
      // if (response.messages) {
      //   toast.error(response.messages[0].message, options);
      //   return false;
      // }
      return false;
    }
  } else return true;
}

export { ToastContainer, ErrorHandler };
